module.exports = __webpack_public_path__ + "img/21 soniar.5a2f8d1f.jpg";